import styled from 'styled-components';
import { Text14Light, Text15Light } from '../../components/utils/Text/Text.styles';
import { Button } from '../../components/utils/Button/Button';
import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg';

export const Container = styled.div`
  width: 100%;
  margin-top: 7rem;

  @media only screen and (max-width: 768px) {
    margin-top: 0;
    padding: 2.4rem 1.6rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NoteText = styled(Text14Light)`
  line-height: 2rem;
  letter-spacing: -0.408px;
  opacity: 0.5;
  margin: 2rem 0;
`;

export const IconWrapper = styled.div`
  height: 2.4rem;
  width: 2.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyDiv = styled.div`
  width: 2.4rem;
`;

export const MethodsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin: 1rem 0 2rem 0;
`;

export const StyledButton = styled(Button)`
  width: 23rem;
  margin-inline: auto;
`;

export const Content = styled.div`
  max-width: 45rem;
  margin-inline: auto;
  padding-bottom: 3rem;
`;

export const W9FormContainer = styled.div``;

export const W9FormDesc = styled(Text15Light)`
  opacity: 0.6;
  margin: 1.2rem 0 1.5rem 0;
`;

export const DownloadFormButton = styled.button`
  padding-inline: 1.2rem;
  border-radius: 12px;
  border: 1px solid #97c9f1;
  background: #fff;
  height: 4.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  outline: none;
  width: 100%;
  margin-bottom: 1.5rem;
`;

export const FileLabel = styled.label`
  border-radius: 12px;
  background: #f3f4f6;
  width: 100%;
  height: 4.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--Main-Purple, #1672ba);
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: -0.408px;
  text-decoration-line: underline;
  cursor: pointer;
  margin-bottom: 1.5rem;
  position: relative;
`;

export const FileInput = styled.input`
  display: none;
`;

export const CloseIcon = styled(CloseSvg)`
  position: absolute;
  right: 1.2rem;
`;
